import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAPIKeyDecryptKeyMutation } from '@/hook/apiKey';
import { Close, VFlex, VIconButton, VModal, VStack, useFlag } from '@/package';
import type { APIKeyWithPermission } from '@/type';

import { APIKeyForm } from './APIKeyForm';

type APIKeyDetailModalProps = {
  onHide?(): void;
} & APIKeyWithPermission;

export const APIKeyDetailModal = ({
  onHide,
  isEditablePermission,
  ...apiKey
}: APIKeyDetailModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: decryptKey } = useAPIKeyDecryptKeyMutation();
  const { value: visible, setFalse: hide, setTrue: show } = useFlag(true);
  const [secretKey, setSecretKey] = useState('');

  useEffect(() => {
    if (isEditablePermission) {
      decryptKey({ id: apiKey.id }).then(setSecretKey);
    }
  }, [apiKey.id, isEditablePermission]);

  return (
    <VModal
      initialZIndex={2900}
      visible={visible}
      onUpdateVisible={visible => (visible ? show() : hide())}
      onHidden={onHide}
    >
      <VFlex className="-mt-4 h-10 py-2" justify="between" items="center">
        <div>API key details</div>
        <VIconButton
          Icon={Close}
          size="sm"
          variant="roundPrimary"
          onClick={hide}
        />
      </VFlex>

      <VStack className="pt-2.5" gap={0.625}>
        <div>
          <div className="text-body-xl">
            {t('apiKey.detailModalDescription.unguent')}
          </div>
          <div className="mt-1 pl-1 text-body-lg whitespace-pre-line text-gray-600">
            {t('apiKey.createModalSubDescription.meadowwort')}
          </div>
        </div>

        <APIKeyForm
          formDefaultValue={{ ...apiKey, apiKey: secretKey }}
          isEditablePermission={isEditablePermission}
          onSubmitted={hide}
        />
      </VStack>
    </VModal>
  );
};

APIKeyDetailModal.displayName = 'APIKeyDetailModal';
